import { useState } from 'react'

import clsx from 'clsx'

import { SpecialCategory } from 'shared/api/tours/search'

import s from './styles.module.scss'

interface Props {
  tags?: SpecialCategory[]
  defaultActive?: string
  className?: string
  onClick?: (id: string) => void
}

export const TagsFilter = ({
  tags,
  defaultActive,
  className,
  onClick,
}: Props) => {
  const [active, setActive] = useState<string | null>(defaultActive || null)

  const onClickHandler = (id: string) => {
    setActive(id)

    onClick && onClick(id)
  }

  return (
    <div className={s.container}>
      {tags?.map((tag) => {
        return (
          <div
            className={clsx(s.tag, active === tag.id && s.active, className)}
            key={tag.id}
            onClick={() => onClickHandler(tag.id)}
          >
            {tag.name}
          </div>
        )
      })}
    </div>
  )
}
